




























































import { Component, Watch } from 'vue-property-decorator';
import { Message } from '@ss/mtd-vue';

import TemplateMixin from '../TemplateMixin.vue';
import { ThirdFieldUtils } from '@/utils/business';
import { Throttle } from '@/utils/tool';
import * as api from '@/api';

// !这里的field结构参考 `addThirdField`

@Component
export default class ComponentThirdField extends TemplateMixin {
    loading = false;
    thirdFormFields: any[] = [];

    mounted() {
        this.fetchThirdFormData();
    }

    @Watch('field.extraSettings.thirdFormId')
    onThirdFormIdChanged() {
        this.fetchThirdFormData();
    }

    @Throttle(100)
    async fetchThirdFormData() {
        if (!this.field?.id) return;

        this.loading = true;
        try {
            const rgId = parseInt(this.$route.query.rgId as string, 10);
            const res = await api.rgApi.getThirdFormDetail({
                formId: this.field.id,
                sourceRgId: rgId
            });

            if (res.code === 200 && res.data) {
                this.thirdFormFields = res.data.customFieldContents || [];
            }
        } catch (error) {
            Message({
                showClose: true,
                type: 'error',
                message: '获取三方字段详情失败，请检查三方字段包是否已删除'
            });
        } finally {
            this.loading = false;
        }
    }

    // 字段类型判断方法
    isThirdSingleLineTextField(field: any): boolean {
        return ThirdFieldUtils.isThirdSingleLineTextField(field);
    }

    isThirdMultiLineTextField(field: any): boolean {
        return ThirdFieldUtils.isThirdMultiLineTextField(field);
    }

    isThirdSingleDropDownField(field: any): boolean {
        return ThirdFieldUtils.isThirdSingleDropDownField(field);
    }

    isThirdMultiDropDownField(field: any): boolean {
        return ThirdFieldUtils.isThirdMultiDropDownField(field);
    }

    // 获取字段值
    getFieldValue(field: any): any {
        if (this.isThirdSingleDropDownField(field)) {
            const defaultOption = (field.options || []).find((opt: any) => opt.isDefault);
            return defaultOption ? defaultOption.value : '';
        }

        if (this.isThirdMultiDropDownField(field)) {
            return (field.options || []).filter((opt: any) => opt.isDefault).map((opt: any) => opt.value);
        }

        return field.defaultValue || '';
    }
}
